import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import {
    getSalesReactBaseUrl,
    getLiveDataClients,
    getLiveDataBranches,
    resetLiveDataMasters,
    probeApiHost,
    gsbillingLoginAuthenticate,
    syncGsbillingCounterData,
    getGsbillingCounterPayload,
    getGsbillingBillDetails,
    sendGsbillingSms,
    sendGsbillingSalesTrackingRecords,
    getGsbillingClientCountUpdation,
    getGsbillingApplicationSetting,
    callbackGsbillingApplicationSetting,
    getGsbillingMastersCreation,
    callbackGsbillingMastersCreation,
    getGsbillingCreditCustomer,
    callbackGsbillingCreditCustomer,
    getGsbillingOutletDetails,
    callbackGsbillingOutletDetails,
    getGsbillingProductCategory,
    callbackGsbillingProductCategory,
    getGsbillingProduct,
    callbackGsbillingProduct,
    getGsbillingUsers,
    callbackGsbillingUsers,
    getGsbillingPrinterDetails,
    callbackGsbillingPrinterDetails,
    getGsbillingNotifications,
    callbackGsbillingNotifications,
    vikrayaLoginAuthenticate,
    getVikrayaBillDetails,
    syncVikrayaCounterData,
    getVikrayaCounterPayload,
    sendVikrayaSms,
    sendVikrayaSalesTrackingRecords,
    getVikrayaClientCountUpdation,
    getVikrayaApplicationSetting,
    callbackVikrayaApplicationSetting,
    getVikrayaMastersCreation,
    callbackVikrayaMastersCreation,
    getVikrayaCreditCustomer,
    callbackVikrayaCreditCustomer,
    getVikrayaOutletDetails,
    callbackVikrayaOutletDetails,
    getVikrayaProductCategory,
    callbackVikrayaProductCategory,
    getVikrayaProduct,
    callbackVikrayaProduct,
    getVikrayaUsers,
    callbackVikrayaUsers,
    getVikrayaPrinterDetails,
    callbackVikrayaPrinterDetails,
    getVikrayaNotifications,
    callbackVikrayaNotifications,
    getVikrayaCreditReport,
    getVikrayaLastBillDetails,
    getVikrayaItemsReport,
    getVikrayaSpecialProductCust,
    getVikrayaCustomerData,
    uploadVikrayaImage,
    getVikrayaRefInformation,
    getVikrayaPaymentCallback,
    rootsalesLoginAuthenticate,
    getRootsalesBillDetails,
    syncRootsalesVikrayaData,
    getRootsalesCounterPayload,
    sendRootsalesSms,
    sendRootsalesSalesTrackingRecords,
    getRootsalesClientCountUpdation,
    getRootsalesApplicationSetting,
    callbackRootsalesApplicationSetting,
    getRootsalesMastersCreation,
    callbackRootsalesMastersCreation,
    getRootsalesCreditCustomer,
    callbackRootsalesCreditCustomer,
    getRootsalesOutletDetails,
    callbackRootsalesOutletDetails,
    getRootsalesProductCategory,
    callbackRootsalesProductCategory,
    getRootsalesProduct,
    callbackRootsalesProduct,
    getRootsalesUsers,
    callbackRootsalesUsers,
    getRootsalesPrinterDetails,
    callbackRootsalesPrinterDetails,
    getRootsalesNotifications,
    callbackRootsalesNotifications,
    getRootsalesCreditReport,
    getRootsalesLastBillDetails,
    getRootsalesItemsReport,
    getRootsalesSpecialProductCust,
    getRootsalesCustomerData,
    uploadRootsalesImage,
    getRootsalesRefInformation,
    getRootsalesPaymentCallback,
    getRootsalesPaymentByDateRange,
    santheLoginAuthenticate,
    getSantheBillDetails,
    syncSantheVikrayaData,
    getSantheCounterPayload,
    sendSantheSms,
    sendSantheSalesTrackingRecords,
    getSantheClientCountUpdation,
    getSantheApplicationSetting,
    callbackSantheApplicationSetting,
    getSantheMastersCreation,
    callbackSantheMastersCreation,
    getSantheCreditCustomer,
    callbackSantheCreditCustomer,
    getSantheOutletDetails,
    callbackSantheOutletDetails,
    getSantheProductCategory,
    callbackSantheProductCategory,
    getSantheProduct,
    callbackSantheProduct,
    getSantheUsers,
    callbackSantheUsers,
    getSanthePrinterDetails,
    callbackSanthePrinterDetails,
    getSantheNotifications,
    callbackSantheNotifications,
    getSantheCreditReport,
    getSantheLastBillDetails,
    getSantheItemsReport,
    getSantheSpecialProductCust,
    getSantheCustomerData,
    uploadSantheImage,
    getSantheRefInformation,
    getSanthePaymentCallback
} from '../utilities/api';

// ════════════════════════════════════════════════════════════════════════════
// Every module below shares one physical host split, confirmed straight from
// each Client\<Module> controller's initController(): $this->db is pinned to
// this deployment's own client database (billing/sync tables, only exist on
// the client's base_url install) and $this->masterDb reads the shared master
// database (reached through client_creation.server_url). Master-data pulls,
// login, and the Get_X/callback_X pairs all read $masterDb → host: 'server'.
// Bill sync, SMS, and the report/helper endpoints read $db → host: 'client'.
// ════════════════════════════════════════════════════════════════════════════

const MASTER_DATA_ENDPOINTS = (basePath, callbackPrefix = 'callback_') => [
    { key: 'get_client_countupdation', label: 'Client Count Updation', method: 'GET', path: `${basePath}/get_client_countupdation/{segment}`, group: 'Master Data Sync', host: 'server' },
    { key: 'Get_application_setting', label: 'Application Setting', method: 'GET', path: `${basePath}/Get_application_setting/{segment}`, group: 'Master Data Sync', host: 'server' },
    { key: `${callbackPrefix}application_setting`, label: 'Callback Application Setting', method: 'POST', path: `${basePath}/${callbackPrefix}application_setting/{segment}`, group: 'Master Data Sync', host: 'server', isCallback: true, sourceKey: 'Get_application_setting', idField: 'app_setting_id' },
    { key: 'Get_masters_creation', label: 'Masters Creation', method: 'GET', path: `${basePath}/Get_masters_creation/{segment}`, group: 'Master Data Sync', host: 'server' },
    { key: `${callbackPrefix}masters_creation`, label: 'Callback Masters Creation', method: 'POST', path: `${basePath}/${callbackPrefix}masters_creation/{segment}`, group: 'Master Data Sync', host: 'server', isCallback: true, sourceKey: 'Get_masters_creation', idField: 'masterId' },
    { key: 'Get_credit_customer', label: 'Credit Customer', method: 'GET', path: `${basePath}/Get_credit_customer/{segment}`, group: 'Master Data Sync', host: 'server' },
    { key: `${callbackPrefix}credit_customer`, label: 'Callback Credit Customer', method: 'POST', path: `${basePath}/${callbackPrefix}credit_customer/{segment}`, group: 'Master Data Sync', host: 'server', isCallback: true, sourceKey: 'Get_credit_customer', idField: 'cust_id' },
    { key: 'Get_outlet_deatils', label: 'Outlet Details', method: 'GET', path: `${basePath}/Get_outlet_deatils/{segment}`, group: 'Master Data Sync', host: 'server' },
    { key: `${callbackPrefix}outlet_deatils`, label: 'Callback Outlet Details', method: 'POST', path: `${basePath}/${callbackPrefix}outlet_deatils/{segment}`, group: 'Master Data Sync', host: 'server', isCallback: true, sourceKey: 'Get_outlet_deatils', idField: 'outId' },
    { key: 'Get_product_category', label: 'Product Category', method: 'GET', path: `${basePath}/Get_product_category/{segment}`, group: 'Master Data Sync', host: 'server' },
    { key: `${callbackPrefix}product_category`, label: 'Callback Product Category', method: 'POST', path: `${basePath}/${callbackPrefix}product_category/{segment}`, group: 'Master Data Sync', host: 'server', isCallback: true, sourceKey: 'Get_product_category', idField: 'pr_cat_id' },
    { key: 'Get_product', label: 'Product', method: 'GET', path: `${basePath}/Get_product/{segment}`, group: 'Master Data Sync', host: 'server' },
    { key: `${callbackPrefix}product`, label: 'Callback Product', method: 'POST', path: `${basePath}/${callbackPrefix}product/{segment}`, group: 'Master Data Sync', host: 'server', isCallback: true, sourceKey: 'Get_product', idField: 'pr_id' },
    { key: 'Get_users', label: 'Users', method: 'GET', path: `${basePath}/Get_users/{segment}`, group: 'Master Data Sync', host: 'server' },
    { key: `${callbackPrefix}users`, label: 'Callback Users', method: 'POST', path: `${basePath}/${callbackPrefix}users/{segment}`, group: 'Master Data Sync', host: 'server', isCallback: true, sourceKey: 'Get_users', idField: 'userId' },
    { key: 'Get_printer_details', label: 'Printer Details', method: 'GET', path: `${basePath}/Get_printer_details/{segment}`, group: 'Master Data Sync', host: 'server' },
    { key: `${callbackPrefix}printer_details`, label: 'Callback Printer Details', method: 'POST', path: `${basePath}/${callbackPrefix}printer_details/{segment}`, group: 'Master Data Sync', host: 'server', isCallback: true, sourceKey: 'Get_printer_details', idField: 'printer_id' },
    { key: 'Get_notifications', label: 'Notifications', method: 'GET', path: `${basePath}/Get_notifications/{segment}`, group: 'Master Data Sync', host: 'server' },
    { key: `${callbackPrefix}notifications`, label: 'Callback Notifications', method: 'POST', path: `${basePath}/${callbackPrefix}notifications/{segment}`, group: 'Master Data Sync', host: 'server', isCallback: true, sourceKey: 'Get_notifications', idField: 'notification_id' }
];

const REPORT_ENDPOINTS = (basePath) => [
    { key: 'get_credit_report', label: 'Credit Report', method: 'GET', path: `${basePath}/get_credit_report/{segment}`, group: 'Reports & Helpers', host: 'client' },
    { key: 'get_lastbill_details', label: 'Last Bill Details', method: 'GET', path: `${basePath}/get_lastbill_details/{segment}/{extra}`, group: 'Reports & Helpers', host: 'client', extraParam: { key: 'cust_id', label: 'Customer ID' } },
    { key: 'get_items_report', label: 'Items Report', method: 'GET', path: `${basePath}/get_items_report/{segment}/{extra}`, group: 'Reports & Helpers', host: 'client', extraParam: { key: 'user_id', label: 'User ID' } },
    { key: 'special_product_cust', label: 'Special Product Pricing', method: 'GET', path: `${basePath}/special_product_cust/{segment}/{extra}`, group: 'Reports & Helpers', host: 'client', extraParam: { key: 'cust_id', label: 'Customer ID' } },
    { key: 'get_customer_data', label: 'Customer Data', method: 'GET', path: `${basePath}/get_customer_data/{segment}`, group: 'Reports & Helpers', host: 'client' },
    { key: 'upload_image', label: 'Upload Image', method: 'POST', path: `${basePath}/upload_image`, group: 'Reports & Helpers', host: 'client', noBranch: true, isUpload: true },
    { key: 'get_ref_inforamtion', label: 'Ref Information', method: 'POST', path: `${basePath}/get_ref_inforamtion`, group: 'Reports & Helpers', host: 'client', noBranch: true },
    { key: 'get_payment_callback', label: 'Payment Callback', method: 'POST', path: `${basePath}/get_payment_callback`, group: 'Reports & Helpers', host: 'client', noBranch: true }
];

const MODULES = {
    gsbilling: {
        label: 'GS Billing',
        icon: 'pi pi-server',
        basePath: 'api/gsbilling',
        syncEndpointKey: 'counterdata_synching',
        syncLabel: 'Counter Data Synching',
        hasResetMasters: true,
        endpoints: [
            { key: 'login_authenticate', label: 'Login Authenticate', method: 'POST', path: 'api/gsbilling/login_authenticate', group: 'Auth & Bill Sync', noBranch: true, host: 'server' },
            { key: 'counterdata_synching', label: 'Counter Data Synching', method: 'POST', path: 'api/gsbilling/counterdata_synching/{segment}', group: 'Auth & Bill Sync', host: 'client' },
            { key: 'get_billdetails', label: 'Get Bill Details', method: 'POST', path: 'api/gsbilling/get_billdetails/{segment}', group: 'Auth & Bill Sync', host: 'client' },
            { key: 'send_sms', label: 'Send SMS', method: 'POST', path: 'api/gsbilling/send_sms/{segment}', group: 'Auth & Bill Sync', host: 'client' },
            { key: 'sales_tracking_records', label: 'Sales Tracking Records', method: 'POST', path: 'api/gsbilling/sales_tracking_records/{segment}', group: 'Auth & Bill Sync', host: 'client' },
            ...MASTER_DATA_ENDPOINTS('api/gsbilling'),
            { key: 'reset_masters', label: 'Reset All Masters', method: 'POST', path: 'api/server_masters/master_table_reset/{segment}', group: 'Masters Data Reset', host: 'local' }
        ],
        handlers: {
            get_billdetails: getGsbillingBillDetails,
            send_sms: sendGsbillingSms,
            sales_tracking_records: sendGsbillingSalesTrackingRecords,
            get_client_countupdation: getGsbillingClientCountUpdation,
            Get_application_setting: getGsbillingApplicationSetting,
            Get_masters_creation: getGsbillingMastersCreation,
            Get_credit_customer: getGsbillingCreditCustomer,
            Get_outlet_deatils: getGsbillingOutletDetails,
            Get_product_category: getGsbillingProductCategory,
            Get_product: getGsbillingProduct,
            Get_users: getGsbillingUsers,
            Get_printer_details: getGsbillingPrinterDetails,
            Get_notifications: getGsbillingNotifications
        },
        callbackHandlers: {
            callback_application_setting: callbackGsbillingApplicationSetting,
            callback_masters_creation: callbackGsbillingMastersCreation,
            callback_credit_customer: callbackGsbillingCreditCustomer,
            callback_outlet_deatils: callbackGsbillingOutletDetails,
            callback_product_category: callbackGsbillingProductCategory,
            callback_product: callbackGsbillingProduct,
            callback_users: callbackGsbillingUsers,
            callback_printer_details: callbackGsbillingPrinterDetails,
            callback_notifications: callbackGsbillingNotifications
        },
        extraParamHandlers: {},
        loginFn: gsbillingLoginAuthenticate,
        syncFn: syncGsbillingCounterData,
        generatePayloadFn: getGsbillingCounterPayload,
        refInfoFn: null,
        paymentFn: null,
        uploadFn: null
    },
    vikraya: {
        label: 'Vikraya',
        icon: 'pi pi-shopping-cart',
        basePath: 'api/vikraya_app',
        syncEndpointKey: 'counterdata_synching',
        syncLabel: 'Counter Data Synching',
        hasResetMasters: false,
        endpoints: [
            { key: 'login_authenticate', label: 'Login Authenticate', method: 'POST', path: 'api/vikraya_app/login_authenticate', group: 'Auth & Bill Sync', noBranch: true, host: 'server' },
            { key: 'counterdata_synching', label: 'Counter Data Synching', method: 'POST', path: 'api/vikraya_app/counterdata_synching/{segment}', group: 'Auth & Bill Sync', host: 'client' },
            { key: 'get_billdetails', label: 'Get Bill Details', method: 'POST', path: 'api/vikraya_app/get_billdetails/{segment}', group: 'Auth & Bill Sync', host: 'client' },
            { key: 'send_sms', label: 'Send SMS', method: 'POST', path: 'api/vikraya_app/send_sms/{segment}', group: 'Auth & Bill Sync', host: 'client' },
            { key: 'sales_tracking_records', label: 'Sales Tracking Records', method: 'POST', path: 'api/vikraya_app/sales_tracking_records/{segment}', group: 'Auth & Bill Sync', host: 'client' },
            ...MASTER_DATA_ENDPOINTS('api/vikraya_app'),
            ...REPORT_ENDPOINTS('api/vikraya_app')
        ],
        handlers: {
            get_billdetails: getVikrayaBillDetails,
            send_sms: sendVikrayaSms,
            sales_tracking_records: sendVikrayaSalesTrackingRecords,
            get_client_countupdation: getVikrayaClientCountUpdation,
            Get_application_setting: getVikrayaApplicationSetting,
            Get_masters_creation: getVikrayaMastersCreation,
            Get_credit_customer: getVikrayaCreditCustomer,
            Get_outlet_deatils: getVikrayaOutletDetails,
            Get_product_category: getVikrayaProductCategory,
            Get_product: getVikrayaProduct,
            Get_users: getVikrayaUsers,
            Get_printer_details: getVikrayaPrinterDetails,
            Get_notifications: getVikrayaNotifications,
            get_credit_report: getVikrayaCreditReport,
            get_customer_data: getVikrayaCustomerData
        },
        callbackHandlers: {
            callback_application_setting: callbackVikrayaApplicationSetting,
            callback_masters_creation: callbackVikrayaMastersCreation,
            callback_credit_customer: callbackVikrayaCreditCustomer,
            callback_outlet_deatils: callbackVikrayaOutletDetails,
            callback_product_category: callbackVikrayaProductCategory,
            callback_product: callbackVikrayaProduct,
            callback_users: callbackVikrayaUsers,
            callback_printer_details: callbackVikrayaPrinterDetails,
            callback_notifications: callbackVikrayaNotifications
        },
        extraParamHandlers: {
            get_lastbill_details: getVikrayaLastBillDetails,
            get_items_report: getVikrayaItemsReport,
            special_product_cust: getVikrayaSpecialProductCust
        },
        loginFn: vikrayaLoginAuthenticate,
        syncFn: syncVikrayaCounterData,
        generatePayloadFn: getVikrayaCounterPayload,
        refInfoFn: getVikrayaRefInformation,
        paymentFn: getVikrayaPaymentCallback,
        uploadFn: uploadVikrayaImage
    },
    rootsales: {
        label: 'RootSales',
        icon: 'pi pi-briefcase',
        basePath: 'api/rootsales',
        syncEndpointKey: 'vikrayadata_synching',
        syncLabel: 'Data Synching',
        hasResetMasters: false,
        endpoints: [
            { key: 'login_authenticate', label: 'Login Authenticate', method: 'POST', path: 'api/rootsales/login_authenticate', group: 'Auth & Bill Sync', noBranch: true, host: 'server' },
            { key: 'vikrayadata_synching', label: 'Data Synching', method: 'POST', path: 'api/rootsales/vikrayadata_synching/{segment}', group: 'Auth & Bill Sync', host: 'client' },
            { key: 'get_billdetails', label: 'Get Bill Details', method: 'POST', path: 'api/rootsales/get_billdetails/{segment}', group: 'Auth & Bill Sync', host: 'client' },
            { key: 'send_sms', label: 'Send SMS', method: 'POST', path: 'api/rootsales/send_sms/{segment}', group: 'Auth & Bill Sync', host: 'client' },
            { key: 'sales_tracking_records', label: 'Sales Tracking Records', method: 'POST', path: 'api/rootsales/sales_tracking_records/{segment}', group: 'Auth & Bill Sync', host: 'client' },
            ...MASTER_DATA_ENDPOINTS('api/rootsales'),
            // upload_image, get_ref_inforamtion and get_payment_callback are branch-scoped
            // for RootSales (unlike Vikraya/Santhe), so their report-endpoint templates need
            // the {segment} path restored here. Special Product Pricing is moved into Master
            // Data Sync — the same group Product (hidden for RootSales, see hiddenKeys) used to sit in.
            ...REPORT_ENDPOINTS('api/rootsales').map((e) => {
                if (['upload_image', 'get_ref_inforamtion', 'get_payment_callback'].includes(e.key)) return { ...e, path: `api/rootsales/${e.key}/{segment}`, noBranch: false };
                if (e.key === 'special_product_cust') return { ...e, group: 'Master Data Sync' };
                return e;
            }),
            // Sales report - payment mode wise by date range. RootSales-only.
            { key: 'payment_bydaterannge', label: 'Payment By Date Range', method: 'POST', path: 'api/rootsales/payment_bydaterannge/{segment}', group: 'Reports & Helpers', host: 'client' }
        ],
        handlers: {
            get_billdetails: getRootsalesBillDetails,
            send_sms: sendRootsalesSms,
            sales_tracking_records: sendRootsalesSalesTrackingRecords,
            get_client_countupdation: getRootsalesClientCountUpdation,
            Get_application_setting: getRootsalesApplicationSetting,
            Get_masters_creation: getRootsalesMastersCreation,
            Get_credit_customer: getRootsalesCreditCustomer,
            Get_outlet_deatils: getRootsalesOutletDetails,
            Get_product_category: getRootsalesProductCategory,
            Get_product: getRootsalesProduct,
            Get_users: getRootsalesUsers,
            Get_printer_details: getRootsalesPrinterDetails,
            Get_notifications: getRootsalesNotifications,
            get_credit_report: getRootsalesCreditReport,
            get_customer_data: getRootsalesCustomerData
        },
        callbackHandlers: {
            callback_application_setting: callbackRootsalesApplicationSetting,
            callback_masters_creation: callbackRootsalesMastersCreation,
            callback_credit_customer: callbackRootsalesCreditCustomer,
            callback_outlet_deatils: callbackRootsalesOutletDetails,
            callback_product_category: callbackRootsalesProductCategory,
            callback_product: callbackRootsalesProduct,
            callback_users: callbackRootsalesUsers,
            callback_printer_details: callbackRootsalesPrinterDetails,
            callback_notifications: callbackRootsalesNotifications
        },
        extraParamHandlers: {
            get_lastbill_details: getRootsalesLastBillDetails,
            get_items_report: getRootsalesItemsReport,
            special_product_cust: getRootsalesSpecialProductCust
        },
        loginFn: rootsalesLoginAuthenticate,
        syncFn: syncRootsalesVikrayaData,
        generatePayloadFn: getRootsalesCounterPayload,
        refInfoFn: getRootsalesRefInformation,
        paymentFn: getRootsalesPaymentCallback,
        paymentByDateRangeFn: getRootsalesPaymentByDateRange,
        uploadFn: uploadRootsalesImage
    },
    santhe: {
        label: 'Santhe',
        icon: 'pi pi-map',
        basePath: 'api/santhe',
        syncEndpointKey: 'vikrayadata_synching',
        syncLabel: 'Data Synching',
        hasResetMasters: false,
        endpoints: [
            { key: 'login_authenticate', label: 'Login Authenticate', method: 'POST', path: 'api/santhe/login_authenticate', group: 'Auth & Bill Sync', noBranch: true, host: 'server' },
            { key: 'vikrayadata_synching', label: 'Data Synching', method: 'POST', path: 'api/santhe/vikrayadata_synching/{segment}', group: 'Auth & Bill Sync', host: 'client' },
            { key: 'get_billdetails', label: 'Get Bill Details', method: 'POST', path: 'api/santhe/get_billdetails/{segment}', group: 'Auth & Bill Sync', host: 'client' },
            { key: 'send_sms', label: 'Send SMS', method: 'POST', path: 'api/santhe/send_sms/{segment}', group: 'Auth & Bill Sync', host: 'client' },
            { key: 'sales_tracking_records', label: 'Sales Tracking Records', method: 'POST', path: 'api/santhe/sales_tracking_records/{segment}', group: 'Auth & Bill Sync', host: 'client' },
            ...MASTER_DATA_ENDPOINTS('api/santhe'),
            ...REPORT_ENDPOINTS('api/santhe')
        ],
        handlers: {
            get_billdetails: getSantheBillDetails,
            send_sms: sendSantheSms,
            sales_tracking_records: sendSantheSalesTrackingRecords,
            get_client_countupdation: getSantheClientCountUpdation,
            Get_application_setting: getSantheApplicationSetting,
            Get_masters_creation: getSantheMastersCreation,
            Get_credit_customer: getSantheCreditCustomer,
            Get_outlet_deatils: getSantheOutletDetails,
            Get_product_category: getSantheProductCategory,
            Get_product: getSantheProduct,
            Get_users: getSantheUsers,
            Get_printer_details: getSanthePrinterDetails,
            Get_notifications: getSantheNotifications,
            get_credit_report: getSantheCreditReport,
            get_customer_data: getSantheCustomerData
        },
        callbackHandlers: {
            callback_application_setting: callbackSantheApplicationSetting,
            callback_masters_creation: callbackSantheMastersCreation,
            callback_credit_customer: callbackSantheCreditCustomer,
            callback_outlet_deatils: callbackSantheOutletDetails,
            callback_product_category: callbackSantheProductCategory,
            callback_product: callbackSantheProduct,
            callback_users: callbackSantheUsers,
            callback_printer_details: callbackSanthePrinterDetails,
            callback_notifications: callbackSantheNotifications
        },
        extraParamHandlers: {
            get_lastbill_details: getSantheLastBillDetails,
            get_items_report: getSantheItemsReport,
            special_product_cust: getSantheSpecialProductCust
        },
        loginFn: santheLoginAuthenticate,
        syncFn: syncSantheVikrayaData,
        generatePayloadFn: getSantheCounterPayload,
        refInfoFn: getSantheRefInformation,
        paymentFn: getSanthePaymentCallback,
        uploadFn: uploadSantheImage
    }
};

const MODULE_OPTIONS = Object.entries(MODULES).map(([value, m]) => ({ label: m.label, value }));

const IS_LOCAL = process.env.NODE_ENV === 'development';
const HOST_MODES = [{ label: 'Server', value: 'server' }, { label: 'Client', value: 'client' }, ...(IS_LOCAL ? [{ label: 'Local', value: 'local' }] : [])];
const HOST_LABELS = { server: 'SERVER', client: 'CLIENT', local: 'LOCAL' };

const GROUP_STYLES = {
    'Auth & Bill Sync': { color: '#1d4ed8', bg: '#eff6ff', accent: '#3b82f6', soft: 'rgba(59, 130, 246, 0.10)', icon: 'pi pi-lock' },
    'Master Data Sync': { color: '#0f766e', bg: '#f0fdfa', accent: '#14b8a6', soft: 'rgba(20, 184, 166, 0.10)', icon: 'pi pi-database' },
    'Masters Data Reset': { color: '#be123c', bg: '#fff1f2', accent: '#f43f5e', soft: 'rgba(244, 63, 94, 0.10)', icon: 'pi pi-refresh' },
    'Reports & Helpers': { color: '#b45309', bg: '#fffbeb', accent: '#f59e0b', soft: 'rgba(245, 158, 11, 0.10)', icon: 'pi pi-chart-bar' }
};
const DEFAULT_GROUP_STYLE = { color: '#374151', bg: '#f9fafb', accent: '#9ca3af', soft: 'rgba(156, 163, 175, 0.12)', icon: 'pi pi-bookmark' };
const groupStyle = (group) => GROUP_STYLES[group] || DEFAULT_GROUP_STYLE;

const LOGIN_TEMPLATE = JSON.stringify({ username: '', password: '' }, null, 2);
const COUNTERDATA_TEMPLATE = JSON.stringify(
    {
        Order: [
            {
                bill_id: '', in_no: '', invoice_no: '', invoice_date: '', invoice_time: '', cust_name: '', cust_phone: '',
                total_amount: '', paid_amt: '', mop: 'CASH', final_mop: 'CASH', branch: '', user_id: '', order_type: 'COUNTER',
                status: 'synched', counter_items: [], counter_payments: []
            }
        ]
    },
    null,
    2
);
const CALLBACK_TEMPLATE = JSON.stringify({ data: [] }, null, 2);
const GENERIC_TEMPLATE = JSON.stringify({}, null, 2);
const REF_INFO_TEMPLATE = JSON.stringify({ ref_no: 'TEST-REF-001' }, null, 2);
const PAYMENT_CALLBACK_TEMPLATE = JSON.stringify(
    { bill_id: 1, amount: '100', payment_type: 'CASH', remarks: 'Test settlement', settlement_date: '' },
    null,
    2
);
const PAYMENT_BYDATERANNGE_TEMPLATE = JSON.stringify({ from_date: '', to_date: '' }, null, 2);

const NO_BODY_HINTS = {
    get_billdetails: 'Select a branch and click Run to read back the highest bill / item / payment ids for that branch. No request body is used.',
    send_sms: "Select a branch and click Run to trigger today's closing-day-sales SMS for that branch. No request body is used.",
    sales_tracking_records: "Builds today's closing-day-sales message from this branch's own bill and payment tables and sends it. No request body is used.",
    Get_printer_details: 'printer_details has no data_transfer column, so this is not an incremental pull — every printer on the branch comes back each time.',
    Get_notifications: "notifications has no data_transfer column, so 'Closed' plays that role — everything not yet closed comes back.",
    get_credit_report: 'Select a branch and click Run to pull its credit report.',
    get_customer_data: 'Select a branch and click Run to pull its customer list.'
};

const displayBaseUrl = () => (process.env.NODE_ENV === 'development' ? 'http://localhost/Counter-Backend' : getSalesReactBaseUrl());
const trimUrl = (url) => String(url || '').replace(/\/+$/, '');
const rawResultText = (data) => (typeof data === 'object' ? JSON.stringify(data, null, 2) : String(data));

const describeError = (err, endpoint) => {
    if (err.response) return err.message;
    const host = endpoint?.host === 'client' ? 'client' : 'server';
    return `${err.message}\n\nNo HTTP response came back. Either that ${host} deployment is down, or the browser blocked the call: this page's origin must be listed in the target's Config/Cors.php allowedOrigins. Switch Host to "Local" to test against the backend serving this UI.`;
};

const extractIds = (raw, idField) => {
    const rows = Array.isArray(raw) ? raw : Array.isArray(raw?.data) ? raw.data : Array.isArray(raw?.Details) ? raw.Details : [];
    return rows.map((r) => r?.[idField]).filter((v) => v !== undefined && v !== null);
};

const Pill = ({ tone, children }) => <span className={`gb-pill gb-pill-${tone}`}>{children}</span>;

const HostCard = ({ tag, tone, url, probe, empty, note }) => {
    const hostState = () => {
        if (!url) return 'none';
        if (probe === null || probe === undefined) return 'unknown';
        if (probe.ok) return 'live';
        return probe.blocked ? 'blocked' : 'down';
    };
    const state = hostState();
    const stateText = {
        none: 'Not configured',
        unknown: 'Not checked',
        live: `Live · ${probe?.duration} ms`,
        blocked: 'Up · blocked by CORS',
        down: probe?.timedOut ? 'No response · timed out' : probe?.statusCode ? `Down · HTTP ${probe.statusCode}` : 'Unreachable'
    }[state];
    return (
        <div className={`gb-host gb-host-${state}`}>
            <div className="gb-host-top">
                <span className={`gb-hostTag gb-hostTag-${tone}`}>{tag}</span>
                <span className={`gb-host-state gb-host-state-${state}`}>
                    <span className="gb-host-dot" />
                    {stateText}
                </span>
            </div>
            <div className="gb-host-url">{url || empty}</div>
            <div className="gb-host-note">{state === 'blocked' ? "Host is reachable. Add this page's origin to that deployment's Config/Cors.php allowedOrigins." : note}</div>
        </div>
    );
};

const ResultPanel = ({ result, maxHeight = 260 }) => {
    const [copied, setCopied] = useState(false);
    if (!result) return null;
    const ok = result.status === 'success';
    const text = rawResultText(result.data);
    const copy = () => {
        if (!navigator.clipboard) return;
        navigator.clipboard.writeText(text).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 1600);
        });
    };
    return (
        <div className={`gb-res ${ok ? 'is-ok' : 'is-err'}`}>
            <div className="gb-res-bar">
                <span className="gb-res-dot" />
                <span className="gb-res-code">{ok ? `${result.statusCode} OK` : `Error ${result.statusCode || ''}`}</span>
                <span className="gb-res-meta">
                    <i className="pi pi-clock" /> {result.duration} ms
                </span>
                {result.testedAt && (
                    <span className="gb-res-meta gb-hide-sm">
                        <i className="pi pi-calendar" /> {result.testedAt}
                    </span>
                )}
                <span className="gb-res-spacer" />
                <button type="button" className="gb-copy" onClick={copy}>
                    <i className={copied ? 'pi pi-check' : 'pi pi-copy'} /> {copied ? 'Copied' : 'Copy'}
                </button>
            </div>
            <pre className="gb-res-body" style={{ maxHeight }}>
                {text}
            </pre>
        </div>
    );
};

const StepHint = ({ icon = 'pi pi-info-circle', children }) => (
    <div className="gb-hint">
        <i className={icon} />
        <span>{children}</span>
    </div>
);
const StepLoading = ({ children }) => (
    <div className="gb-hint gb-hint-loading">
        <i className="pi pi-spin pi-spinner" />
        <span>{children}</span>
    </div>
);

const StepBlock = ({ title, action, method, url, loading, loadingText, result, emptyHint, maxHeight = 260 }) => (
    <div className="gb-step">
        {title && <div className="gb-step-title">{title}</div>}
        <div className="gb-reqbar">
            <span className={`gb-reqbar-method gb-method-${method.toLowerCase()}`}>{method}</span>
            <span className="gb-reqbar-url">{url}</span>
            <span className="gb-reqbar-action">{action}</span>
        </div>
        {loading && <StepLoading>{loadingText || 'Loading…'}</StepLoading>}
        {result ? <ResultPanel result={result} maxHeight={maxHeight} /> : !loading && <StepHint>{emptyHint}</StepHint>}
    </div>
);

const PostBodyStep = ({ title, url, bodyText, onBodyChange, onRun, loading, loadingText, result, sendLabel = 'Send', maxHeight = 260 }) => (
    <div className="gb-step">
        {title && <div className="gb-step-title">{title}</div>}
        <div className="gb-reqbar">
            <span className="gb-reqbar-method gb-method-post">POST</span>
            <span className="gb-reqbar-url">{url}</span>
            <span className="gb-reqbar-action">
                <Button label={sendLabel} icon="pi pi-send" className="p-button-sm" onClick={onRun} loading={loading} />
            </span>
        </div>
        <div className="gb-editor">
            <div className="gb-editor-bar">
                <i className="pi pi-code" />
                <span>Request body</span>
                <span className="gb-res-spacer" />
                <span className="gb-editor-tag">JSON</span>
            </div>
            <textarea className="gb-json-edit" value={bodyText} onChange={(e) => onBodyChange(e.target.value)} spellCheck={false} />
        </div>
        {loading && <StepLoading>{loadingText || 'Sending…'}</StepLoading>}
        {result && <ResultPanel result={result} maxHeight={maxHeight} />}
    </div>
);

const ExtraParamStep = ({ paramLabel, paramValue, onParamChange, method, url, action, loading, loadingText, result, emptyHint, maxHeight = 260 }) => (
    <div className="gb-step">
        <div className="gb-field" style={{ marginBottom: 12, maxWidth: 320 }}>
            <label className="gb-field-label">
                <i className="pi pi-hashtag" /> {paramLabel}
            </label>
            <InputText value={paramValue} onChange={(e) => onParamChange(e.target.value)} placeholder={`Enter ${paramLabel.toLowerCase()}`} className="w-full" />
        </div>
        <div className="gb-reqbar">
            <span className={`gb-reqbar-method gb-method-${method.toLowerCase()}`}>{method}</span>
            <span className="gb-reqbar-url">{url}</span>
            <span className="gb-reqbar-action">{action}</span>
        </div>
        {loading && <StepLoading>{loadingText || 'Loading…'}</StepLoading>}
        {result ? <ResultPanel result={result} maxHeight={maxHeight} /> : !loading && <StepHint>{emptyHint}</StepHint>}
    </div>
);

const UploadStep = ({ url, file, onFileChange, extraFields, onExtraFieldsChange, onRun, loading, result }) => (
    <div className="gb-step">
        <div className="gb-reqbar">
            <span className="gb-reqbar-method gb-method-post">POST</span>
            <span className="gb-reqbar-url">{url}</span>
            <span className="gb-reqbar-action">
                <Button label="Upload" icon="pi pi-upload" className="p-button-sm" onClick={onRun} loading={loading} disabled={!file} />
            </span>
        </div>
        <div className="gb-field" style={{ marginTop: 12, maxWidth: 420 }}>
            <label className="gb-field-label">
                <i className="pi pi-image" /> Image file
            </label>
            <input type="file" accept="image/*" onChange={(e) => onFileChange(e.target.files?.[0] || null)} />
        </div>
        <div className="gb-editor" style={{ marginTop: 12 }}>
            <div className="gb-editor-bar">
                <i className="pi pi-code" />
                <span>Extra form fields (JSON object — merged in alongside the file)</span>
                <span className="gb-res-spacer" />
                <span className="gb-editor-tag">JSON</span>
            </div>
            <textarea className="gb-json-edit" value={extraFields} onChange={(e) => onExtraFieldsChange(e.target.value)} spellCheck={false} />
        </div>
        {loading && <StepLoading>Uploading…</StepLoading>}
        {result && <ResultPanel result={result} />}
    </div>
);

export default function ApiEndpoints() {
    const toast = useRef(null);

    const [activeModule, setActiveModule] = useState('gsbilling');
    const mod = MODULES[activeModule];

    const [clients, setClients] = useState([]);
    const [branches, setBranches] = useState([]);
    const [branchesLoading, setBranchesLoading] = useState(false);
    const [selectedClient, setSelectedClient] = useState(null);
    const [selectedBranch, setSelectedBranch] = useState(null);
    const branchCacheRef = useRef(new Map());

    const [clientUrls, setClientUrls] = useState({ base_url: '', server_url: '' });
    const [hostMode, setHostMode] = useState(IS_LOCAL ? 'local' : 'server');
    const [hostProbe, setHostProbe] = useState({ server: null, client: null });
    const [probing, setProbing] = useState(false);

    const [results, setResults] = useState({});
    const [runningKeys, setRunningKeys] = useState(new Set());
    const [postBody, setPostBody] = useState({});
    const [postResults, setPostResults] = useState({});
    const [postLoading, setPostLoading] = useState({});
    const [extraParams, setExtraParams] = useState({});
    const [uploadFile, setUploadFile] = useState(null);
    const [uploadExtraFields, setUploadExtraFields] = useState('{}');
    const [syncPayload, setSyncPayload] = useState({});
    const [syncPayloadLoading, setSyncPayloadLoading] = useState({});

    const [selectedEndpoint, setSelectedEndpoint] = useState(null);
    const [search, setSearch] = useState('');
    const [collapsedGroups, setCollapsedGroups] = useState(new Set());

    const [resetVisible, setResetVisible] = useState(false);
    const [resetLoading, setResetLoading] = useState(false);

    // Every stateful dict below is keyed by `${module}::${endpointKey}` — several
    // modules reuse the exact same endpoint key (e.g. every module has a
    // "Get_application_setting"), so a bare key would show one module's last
    // result under another module's item the moment you switched tabs.
    const rk = (key) => `${activeModule}::${key}`;

    const toggleGroup = (group) => {
        setCollapsedGroups((prev) => {
            const next = new Set(prev);
            if (next.has(group)) next.delete(group);
            else next.add(group);
            return next;
        });
    };

    useEffect(() => {
        fetchClients();
    }, []);

    // Switching modules keeps the picked client/branch (its base_url/server_url
    // apply to every module identically) but clears the endpoint selection and
    // upload/extra-param scratch state, since those are endpoint-shaped, not data.
    useEffect(() => {
        setSelectedEndpoint(null);
        setSearch('');
        setCollapsedGroups(new Set());
        setUploadFile(null);
        setUploadExtraFields('{}');
    }, [activeModule]);

    useEffect(() => {
        if (!selectedEndpoint?.isCallback) return;
        const r = results[rk(selectedEndpoint.sourceKey)];
        if (r?.status !== 'success') return;
        const key = rk(selectedEndpoint.key);
        setPostBody((prev) => {
            if (prev[key] !== undefined) return prev;
            const ids = extractIds(r.data, selectedEndpoint.idField);
            return { ...prev, [key]: JSON.stringify({ data: ids }, null, 2) };
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [results, selectedEndpoint, activeModule]);

    const fetchClients = async () => {
        try {
            const data = await getLiveDataClients();
            setClients(data.map((c) => ({ label: c.client_name, value: c.client_id, base_url: c.base_url || '', server_url: c.server_url || '' })));
        } catch {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to load clients' });
        }
    };

    const fetchBranches = async (clientId) => {
        const cached = branchCacheRef.current.get(clientId);
        if (cached) {
            setBranches(cached);
            return;
        }
        setBranchesLoading(true);
        try {
            const data = await getLiveDataBranches(clientId);
            const options = data.map((b) => ({ label: b.branch_name, value: b.branch_id }));
            branchCacheRef.current.set(clientId, options);
            setBranches(options);
        } catch {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to load branches' });
        } finally {
            setBranchesLoading(false);
        }
    };

    const currentSegment = () => {
        const branchObj = branches.find((b) => b.value === selectedBranch);
        return branchObj ? branchObj.label : selectedBranch || '';
    };

    const serverUrl = trimUrl(clientUrls.server_url);
    const clientUrl = trimUrl(clientUrls.base_url);

    const resolveHost = (endpoint) => {
        const localHost = { baseUrl: '', host: 'local', why: 'This backend' };
        if (!endpoint || endpoint.host === 'local' || hostMode === 'local') return localHost;
        if (endpoint.host === 'client' || hostMode === 'client') {
            if (!clientUrl) return { ...localHost, why: 'No client base_url configured — falling back to this backend' };
            return { baseUrl: clientUrl, host: 'client', why: endpoint.host === 'client' ? 'Fixed to the client deployment — its billing tables live there' : 'Sent to the client deployment' };
        }
        if (!serverUrl) return { ...localHost, why: 'No server_url configured — falling back to this backend' };
        return { baseUrl: serverUrl, host: 'server', why: 'Sent to the server deployment' };
    };

    const resolveUrl = (endpoint, extraValue) => {
        const { baseUrl } = resolveHost(endpoint);
        let path = endpoint.path.replace('{segment}', currentSegment());
        if (endpoint.extraParam) path = path.replace('{extra}', extraValue || `{${endpoint.extraParam.key}}`);
        return `${baseUrl || displayBaseUrl()}/${path}`;
    };

    const checkHosts = async () => {
        const segment = currentSegment();
        if (!segment) {
            toast.current.show({ severity: 'warn', summary: 'Branch Required', detail: 'Select a client and branch first' });
            return;
        }
        setProbing(true);
        try {
            const probePath = `${mod.basePath}/Get_application_setting/${encodeURIComponent(segment)}`;
            const [server, client] = await Promise.all([
                serverUrl ? probeApiHost(`${trimUrl(serverUrl)}/${probePath}`) : Promise.resolve(null),
                clientUrl ? probeApiHost(`${trimUrl(clientUrl)}/${probePath}`) : Promise.resolve(null)
            ]);
            setHostProbe({ server, client });
        } finally {
            setProbing(false);
        }
    };

    const runEndpoint = async (endpoint) => {
        const needsSegment = endpoint.path.includes('{segment}') && !endpoint.noBranch;
        if (needsSegment && !selectedBranch) {
            toast.current.show({ severity: 'warn', summary: 'Branch Required', detail: 'Please select a client and branch first' });
            return;
        }
        const key = rk(endpoint.key);
        setRunningKeys((prev) => new Set(prev).add(key));
        const t0 = Date.now();
        try {
            const data = await mod.handlers[endpoint.key](currentSegment(), resolveHost(endpoint).baseUrl);
            setResults((prev) => ({ ...prev, [key]: { status: 'success', statusCode: 200, data, duration: Date.now() - t0, testedAt: new Date().toLocaleTimeString() } }));
        } catch (err) {
            setResults((prev) => ({
                ...prev,
                [key]: { status: 'error', statusCode: err.response?.status || 0, data: err.response?.data || describeError(err, endpoint), duration: Date.now() - t0, testedAt: new Date().toLocaleTimeString() }
            }));
        } finally {
            setRunningKeys((prev) => {
                const n = new Set(prev);
                n.delete(key);
                return n;
            });
        }
    };

    const runExtraParamEndpoint = async (endpoint) => {
        if (!selectedBranch) {
            toast.current.show({ severity: 'warn', summary: 'Branch Required', detail: 'Please select a client and branch first' });
            return;
        }
        const key = rk(endpoint.key);
        const value = (extraParams[key] || '').trim();
        if (!value) {
            toast.current.show({ severity: 'warn', summary: `${endpoint.extraParam.label} Required`, detail: `Enter a ${endpoint.extraParam.label.toLowerCase()} first` });
            return;
        }
        setRunningKeys((prev) => new Set(prev).add(key));
        const t0 = Date.now();
        try {
            const data = await mod.extraParamHandlers[endpoint.key](currentSegment(), value, resolveHost(endpoint).baseUrl);
            setResults((prev) => ({ ...prev, [key]: { status: 'success', statusCode: 200, data, duration: Date.now() - t0, testedAt: new Date().toLocaleTimeString() } }));
        } catch (err) {
            setResults((prev) => ({
                ...prev,
                [key]: { status: 'error', statusCode: err.response?.status || 0, data: err.response?.data || describeError(err, endpoint), duration: Date.now() - t0, testedAt: new Date().toLocaleTimeString() }
            }));
        } finally {
            setRunningKeys((prev) => {
                const n = new Set(prev);
                n.delete(key);
                return n;
            });
        }
    };

    const runPostBody = async (endpoint, { requiresBranch = true, buildRequest, defaultBody }) => {
        if (requiresBranch && !selectedBranch) {
            toast.current.show({ severity: 'warn', summary: 'Branch Required', detail: 'Please select a client and branch first' });
            return;
        }
        const key = rk(endpoint.key);
        const bodyText = postBody[key] ?? defaultBody;
        let parsed;
        try {
            parsed = bodyText.trim() ? JSON.parse(bodyText) : {};
        } catch (e) {
            setPostResults((prev) => ({ ...prev, [key]: { status: 'error', statusCode: 0, data: `Invalid JSON: ${e.message}`, duration: 0, testedAt: new Date().toLocaleTimeString() } }));
            return;
        }
        setPostLoading((prev) => ({ ...prev, [key]: true }));
        const t0 = Date.now();
        try {
            const data = await buildRequest(currentSegment(), parsed, resolveHost(endpoint).baseUrl);
            setPostResults((prev) => ({ ...prev, [key]: { status: 'success', statusCode: 200, data, duration: Date.now() - t0, testedAt: new Date().toLocaleTimeString() } }));
        } catch (err) {
            setPostResults((prev) => ({
                ...prev,
                [key]: { status: 'error', statusCode: err.response?.status || 0, data: err.response?.data || describeError(err, endpoint), duration: Date.now() - t0, testedAt: new Date().toLocaleTimeString() }
            }));
        } finally {
            setPostLoading((prev) => ({ ...prev, [key]: false }));
        }
    };

    const runGeneratePayload = async (endpoint) => {
        if (!selectedBranch) {
            toast.current.show({ severity: 'warn', summary: 'Branch Required', detail: 'Please select a client and branch first' });
            return;
        }
        const key = rk(endpoint.key);
        setSyncPayloadLoading((prev) => ({ ...prev, [key]: true }));
        const t0 = Date.now();
        try {
            const data = await mod.generatePayloadFn(currentSegment(), resolveHost(endpoint).baseUrl);
            setSyncPayload((prev) => ({ ...prev, [key]: { status: 'success', statusCode: 200, data, duration: Date.now() - t0, testedAt: new Date().toLocaleTimeString() } }));
        } catch (err) {
            setSyncPayload((prev) => ({
                ...prev,
                [key]: { status: 'error', statusCode: err.response?.status || 0, data: err.response?.data || describeError(err, endpoint), duration: Date.now() - t0, testedAt: new Date().toLocaleTimeString() }
            }));
        } finally {
            setSyncPayloadLoading((prev) => ({ ...prev, [key]: false }));
        }
    };

    const runGeneratedSync = async (endpoint) => {
        const key = rk(endpoint.key);
        const generated = syncPayload[key];
        if (!generated || generated.status !== 'success') return;
        setPostLoading((prev) => ({ ...prev, [key]: true }));
        const t0 = Date.now();
        try {
            const data = await mod.syncFn(currentSegment(), generated.data, resolveHost(endpoint).baseUrl);
            setPostResults((prev) => ({ ...prev, [key]: { status: 'success', statusCode: 200, data, duration: Date.now() - t0, testedAt: new Date().toLocaleTimeString() } }));
        } catch (err) {
            setPostResults((prev) => ({
                ...prev,
                [key]: { status: 'error', statusCode: err.response?.status || 0, data: err.response?.data || describeError(err, endpoint), duration: Date.now() - t0, testedAt: new Date().toLocaleTimeString() }
            }));
        } finally {
            setPostLoading((prev) => ({ ...prev, [key]: false }));
        }
    };

    const runUpload = async (endpoint) => {
        if (!uploadFile) return;
        const needsBranch = !endpoint.noBranch;
        if (needsBranch && !selectedBranch) {
            toast.current.show({ severity: 'warn', summary: 'Branch Required', detail: 'Please select a client and branch first' });
            return;
        }
        const key = rk(endpoint.key);
        let extra = {};
        try {
            extra = uploadExtraFields.trim() ? JSON.parse(uploadExtraFields) : {};
        } catch (e) {
            setPostResults((prev) => ({ ...prev, [key]: { status: 'error', statusCode: 0, data: `Invalid JSON: ${e.message}`, duration: 0, testedAt: new Date().toLocaleTimeString() } }));
            return;
        }
        setPostLoading((prev) => ({ ...prev, [key]: true }));
        const t0 = Date.now();
        try {
            const formData = new FormData();
            formData.append('photo', uploadFile);
            Object.entries(extra).forEach(([k, v]) => formData.append(k, v));
            const data = needsBranch
                ? await mod.uploadFn(currentSegment(), formData, resolveHost(endpoint).baseUrl)
                : await mod.uploadFn(formData, resolveHost(endpoint).baseUrl);
            setPostResults((prev) => ({ ...prev, [key]: { status: 'success', statusCode: 200, data, duration: Date.now() - t0, testedAt: new Date().toLocaleTimeString() } }));
        } catch (err) {
            setPostResults((prev) => ({
                ...prev,
                [key]: { status: 'error', statusCode: err.response?.status || 0, data: err.response?.data || describeError(err, endpoint), duration: Date.now() - t0, testedAt: new Date().toLocaleTimeString() }
            }));
        } finally {
            setPostLoading((prev) => ({ ...prev, [key]: false }));
        }
    };

    const resetMasters = async () => {
        const segment = currentSegment();
        const key = rk('reset_masters');
        const t0 = Date.now();
        setResetLoading(true);
        try {
            const data = await resetLiveDataMasters(segment);
            setResults((prev) => ({ ...prev, [key]: { status: 'success', statusCode: 200, data, duration: Date.now() - t0, testedAt: new Date().toLocaleTimeString() } }));
            toast.current.show({ severity: 'success', summary: 'Reset Successful', detail: `All masters reset for branch ${segment}` });
            setResetVisible(false);
        } catch (err) {
            setResults((prev) => ({
                ...prev,
                [key]: { status: 'error', statusCode: err.response?.status || 0, data: err.response?.data || err.message, duration: Date.now() - t0, testedAt: new Date().toLocaleTimeString() }
            }));
            toast.current.show({ severity: 'error', summary: 'Reset Failed', detail: err.response?.data?.message || 'Something went wrong' });
        } finally {
            setResetLoading(false);
        }
    };

    const selectEndpoint = (endpoint) => setSelectedEndpoint(endpoint);

    const statusInfo = (endpoint) => {
        const key = rk(endpoint.key);
        if (runningKeys.has(key) || postLoading[key]) return { text: 'Running…', severity: 'info' };
        const r = postResults[key] || results[key];
        if (!r) return { text: 'Not Tested', severity: 'secondary' };
        return r.status === 'success' ? { text: `${r.statusCode} OK`, severity: 'success' } : { text: `Error ${r.statusCode || ''}`, severity: 'danger' };
    };

    const successCount = mod.endpoints.filter((e) => statusInfo(e).severity === 'success').length;
    const failCount = mod.endpoints.filter((e) => statusInfo(e).severity === 'danger').length;
    const notTested = mod.endpoints.length - successCount - failCount;
    const coverage = Math.round(((successCount + failCount) / mod.endpoints.length) * 100);

    const groupedEndpoints = useMemo(() => {
        const q = search.trim().toLowerCase();
        const hiddenKeys = [
            'sales_tracking_records',
            'get_billdetails',
            ...(['vikraya', 'rootsales'].includes(activeModule) ? [] : ['special_product_cust']),
            ...(['vikraya', 'rootsales', 'santhe'].includes(activeModule) ? ['Get_credit_customer', 'callback_credit_customer'] : []),
            ...(activeModule !== 'rootsales' ? ['upload_image', 'get_ref_inforamtion', 'get_payment_callback'] : []),
            // RootSales: Product is replaced by Special Product Pricing in the Master Data Sync group.
            ...(activeModule === 'rootsales' ? ['Get_product', 'callback_product'] : []),
            // Santhe: these report endpoints aren't applicable, so hide them from the left list.
            ...(activeModule === 'santhe' ? ['get_credit_report', 'get_items_report', 'get_customer_data', 'get_lastbill_details'] : [])
        ];
        const visible = mod.endpoints.filter((e) => !hiddenKeys.includes(e.key));
        const filtered = q ? visible.filter((e) => e.label.toLowerCase().includes(q)) : visible;
        const groups = {};
        filtered.forEach((e) => {
            groups[e.group] = groups[e.group] || [];
            groups[e.group].push(e);
        });
        return groups;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search, activeModule]);

    const renderDetailBody = () => {
        if (!selectedEndpoint) return null;
        const ep = selectedEndpoint;
        const key = rk(ep.key);

        if (ep.key === 'login_authenticate') {
            return (
                <PostBodyStep
                    url={resolveUrl(ep)}
                    bodyText={postBody[key] ?? LOGIN_TEMPLATE}
                    onBodyChange={(v) => setPostBody((prev) => ({ ...prev, [key]: v }))}
                    onRun={() => runPostBody(ep, { requiresBranch: false, buildRequest: (_, parsed, url) => mod.loginFn(parsed, url), defaultBody: LOGIN_TEMPLATE })}
                    loading={!!postLoading[key]}
                    loadingText="Authenticating…"
                    result={postResults[key]}
                    sendLabel="Login"
                />
            );
        }

        if (ep.key === mod.syncEndpointKey && mod.generatePayloadFn) {
            const genResult = syncPayload[key];
            const genOk = genResult?.status === 'success';
            return (
                <>
                    <StepBlock
                        title="1. Generate Payload"
                        method="GET"
                        url={`${resolveHost(ep).baseUrl || displayBaseUrl()}/${mod.basePath}/generate_counter_payload/${currentSegment()}`}
                        action={<Button label="Generate" icon="pi pi-play" className="p-button-sm" onClick={() => runGeneratePayload(ep)} loading={!!syncPayloadLoading[key]} />}
                        result={genResult}
                        emptyHint="Click Generate to pull this branch's latest bill as a ready-to-sync payload — or a sample payload if the branch has no bills yet."
                        maxHeight={260}
                    />
                    <StepBlock
                        title="2. Push & Sync"
                        method="POST"
                        url={resolveUrl(ep)}
                        action={<Button label="Push & Sync" icon="pi pi-cloud-upload" className="p-button-sm" onClick={() => runGeneratedSync(ep)} loading={!!postLoading[key]} disabled={!genOk} />}
                        result={postResults[key]}
                        emptyHint="Complete Step 1 first, then click Push & Sync to send the generated payload to Counter Data Synching."
                        maxHeight={320}
                    />
                </>
            );
        }

        if (ep.key === mod.syncEndpointKey) {
            return (
                <PostBodyStep
                    url={resolveUrl(ep)}
                    bodyText={postBody[key] ?? COUNTERDATA_TEMPLATE}
                    onBodyChange={(v) => setPostBody((prev) => ({ ...prev, [key]: v }))}
                    onRun={() => runPostBody(ep, { requiresBranch: true, buildRequest: (segment, parsed, url) => mod.syncFn(segment, parsed, url), defaultBody: COUNTERDATA_TEMPLATE })}
                    loading={!!postLoading[key]}
                    loadingText="Syncing…"
                    result={postResults[key]}
                    sendLabel="Sync"
                    maxHeight={320}
                />
            );
        }

        if (ep.key === 'reset_masters') {
            return (
                <StepBlock
                    method="POST"
                    url={resolveUrl(ep)}
                    action={<Button label="Reset Masters" icon="pi pi-database" className="p-button-sm gb-btn-danger" onClick={() => setResetVisible(true)} disabled={!selectedBranch} />}
                    result={results[key]}
                    emptyHint="Select a branch and click Reset Masters to wipe and re-flag all master tables for that branch. This cannot be undone."
                    maxHeight={320}
                />
            );
        }

        if (ep.isUpload) {
            return (
                <UploadStep
                    url={resolveUrl(ep)}
                    file={uploadFile}
                    onFileChange={setUploadFile}
                    extraFields={uploadExtraFields}
                    onExtraFieldsChange={setUploadExtraFields}
                    onRun={() => runUpload(ep)}
                    loading={!!postLoading[key]}
                    result={postResults[key]}
                />
            );
        }

        if (ep.key === 'get_ref_inforamtion') {
            const needsBranch = !ep.noBranch;
            return (
                <PostBodyStep
                    title="Sample payload below — edit freely and inspect the response."
                    url={resolveUrl(ep)}
                    bodyText={postBody[key] ?? REF_INFO_TEMPLATE}
                    onBodyChange={(v) => setPostBody((prev) => ({ ...prev, [key]: v }))}
                    onRun={() => runPostBody(ep, { requiresBranch: needsBranch, buildRequest: (segment, parsed, url) => (needsBranch ? mod.refInfoFn(segment, parsed, url) : mod.refInfoFn(parsed, url)), defaultBody: REF_INFO_TEMPLATE })}
                    loading={!!postLoading[key]}
                    loadingText="Sending…"
                    result={postResults[key]}
                />
            );
        }

        if (ep.key === 'get_payment_callback') {
            const needsBranch = !ep.noBranch;
            return (
                <PostBodyStep
                    title="Sample payload below — edit freely and inspect the response."
                    url={resolveUrl(ep)}
                    bodyText={postBody[key] ?? PAYMENT_CALLBACK_TEMPLATE}
                    onBodyChange={(v) => setPostBody((prev) => ({ ...prev, [key]: v }))}
                    onRun={() => runPostBody(ep, { requiresBranch: needsBranch, buildRequest: (segment, parsed, url) => (needsBranch ? mod.paymentFn(segment, parsed, url) : mod.paymentFn(parsed, url)), defaultBody: PAYMENT_CALLBACK_TEMPLATE })}
                    loading={!!postLoading[key]}
                    loadingText="Sending…"
                    result={postResults[key]}
                />
            );
        }

        if (ep.key === 'payment_bydaterannge') {
            return (
                <PostBodyStep
                    title="Sample payload below — edit freely and inspect the response."
                    url={resolveUrl(ep)}
                    bodyText={postBody[key] ?? PAYMENT_BYDATERANNGE_TEMPLATE}
                    onBodyChange={(v) => setPostBody((prev) => ({ ...prev, [key]: v }))}
                    onRun={() => runPostBody(ep, { requiresBranch: true, buildRequest: (segment, parsed, url) => mod.paymentByDateRangeFn(segment, parsed, url), defaultBody: PAYMENT_BYDATERANNGE_TEMPLATE })}
                    loading={!!postLoading[key]}
                    loadingText="Fetching…"
                    result={postResults[key]}
                />
            );
        }

        if (ep.isCallback) {
            const sourceLabel = mod.endpoints.find((e) => e.key === ep.sourceKey)?.label;
            return (
                <PostBodyStep
                    title={results[rk(ep.sourceKey)] ? `IDs pre-filled from the last ${sourceLabel} fetch — edit if needed.` : `Run ${sourceLabel} first to pre-fill the pending IDs, or paste them below.`}
                    url={resolveUrl(ep)}
                    bodyText={postBody[key] ?? CALLBACK_TEMPLATE}
                    onBodyChange={(v) => setPostBody((prev) => ({ ...prev, [key]: v }))}
                    onRun={() => runPostBody(ep, { requiresBranch: true, buildRequest: (segment, parsed, url) => mod.callbackHandlers[ep.key](segment, parsed, url), defaultBody: CALLBACK_TEMPLATE })}
                    loading={!!postLoading[key]}
                    loadingText="Acknowledging…"
                    result={postResults[key]}
                    sendLabel="Acknowledge"
                />
            );
        }

        if (ep.extraParam) {
            return (
                <ExtraParamStep
                    paramLabel={ep.extraParam.label}
                    paramValue={extraParams[key] || ''}
                    onParamChange={(v) => setExtraParams((prev) => ({ ...prev, [key]: v }))}
                    method={ep.method}
                    url={resolveUrl(ep, extraParams[key])}
                    action={<Button label="Run" icon="pi pi-play" className="p-button-sm" onClick={() => runExtraParamEndpoint(ep)} loading={runningKeys.has(key)} />}
                    result={results[key]}
                    emptyHint={`Select a branch, enter a ${ep.extraParam.label.toLowerCase()}, and click Run.`}
                    maxHeight={320}
                />
            );
        }

        return (
            <StepBlock
                method={ep.method}
                url={resolveUrl(ep)}
                action={<Button label="Run" icon="pi pi-play" className="p-button-sm" onClick={() => runEndpoint(ep)} loading={runningKeys.has(key)} />}
                result={results[key]}
                emptyHint={NO_BODY_HINTS[ep.key] || `Select a branch and click Run to fetch pending ${ep.label.toLowerCase()} rows.`}
                maxHeight={320}
            />
        );
    };

    const detailStyle = selectedEndpoint ? groupStyle(selectedEndpoint.group) : DEFAULT_GROUP_STYLE;

    return (
        <div className="apiep-page">
            <Toast ref={toast} />
            <style>{`
                .apiep-page { padding: 1.25rem; background: #f4f5fa; min-height: 100%; }
                .apiep-page .gb-hero { position: relative; overflow: hidden; border-radius: 18px; padding: 22px 26px; margin-bottom: 16px;
                    background: linear-gradient(135deg, #1e1b4b 0%, #4338ca 45%, #6366f1 100%);
                    box-shadow: 0 12px 30px -12px rgba(67, 56, 202, 0.5); display: flex; gap: 24px; align-items: center; flex-wrap: wrap; }
                .apiep-page .gb-hero::after { content: ''; position: absolute; right: -70px; top: -110px; width: 320px; height: 320px; border-radius: 50%;
                    background: radial-gradient(circle, rgba(255,255,255,0.16) 0%, rgba(255,255,255,0) 68%); pointer-events: none; }
                .apiep-page .gb-hero-main { display: flex; align-items: center; gap: 16px; flex: 1; min-width: 280px; position: relative; z-index: 1; }
                .apiep-page .gb-hero-icon { width: 52px; height: 52px; flex-shrink: 0; border-radius: 14px; display: flex; align-items: center; justify-content: center;
                    background: rgba(255,255,255,0.16); border: 1px solid rgba(255,255,255,0.25); backdrop-filter: blur(6px); }
                .apiep-page .gb-hero-icon i { font-size: 1.5rem; color: #fff; }
                .apiep-page .gb-hero-title { margin: 0; font-size: 1.4rem; font-weight: 800; color: #fff; letter-spacing: -0.02em; line-height: 1.2; }
                .apiep-page .gb-hero-sub { margin: 5px 0 0; font-size: 0.82rem; color: rgba(255,255,255,0.78); max-width: 640px; line-height: 1.45; }
                .apiep-page .gb-stats { display: flex; gap: 10px; flex-wrap: wrap; position: relative; z-index: 1; }
                .apiep-page .gb-stat { min-width: 96px; padding: 10px 14px; border-radius: 12px; background: rgba(255,255,255,0.12);
                    border: 1px solid rgba(255,255,255,0.18); backdrop-filter: blur(8px); transition: transform .18s ease, background-color .18s ease; }
                .apiep-page .gb-stat:hover { transform: translateY(-2px); background: rgba(255,255,255,0.18); }
                .apiep-page .gb-stat-value { font-size: 1.4rem; font-weight: 800; color: #fff; line-height: 1.1; display: flex; align-items: center; gap: 7px; }
                .apiep-page .gb-stat-value i { font-size: 0.8rem; }
                .apiep-page .gb-stat-label { font-size: 0.63rem; font-weight: 700; letter-spacing: 0.09em; text-transform: uppercase; color: rgba(255,255,255,0.7); margin-top: 3px; }
                .apiep-page .gb-stat.ok .gb-stat-value i { color: #6ee7b7; }
                .apiep-page .gb-stat.err .gb-stat-value i { color: #fda4af; }
                .apiep-page .gb-stat.idle .gb-stat-value i { color: #cbd5e1; }
                .apiep-page .gb-stat.all .gb-stat-value i { color: #c4b5fd; }
                .apiep-page .gb-progress { height: 4px; border-radius: 4px; background: rgba(255,255,255,0.2); margin-top: 8px; overflow: hidden; }
                .apiep-page .gb-progress span { display: block; height: 100%; border-radius: 4px; background: linear-gradient(90deg, #a78bfa, #6ee7b7); transition: width .4s ease; }

                .apiep-page .gb-toolbar { background: #fff; border: 1px solid #e8eaf2; border-radius: 16px; padding: 14px 18px; margin-bottom: 16px;
                    box-shadow: 0 2px 10px -4px rgba(15, 23, 42, 0.10); display: flex; gap: 16px; align-items: flex-end; flex-wrap: wrap; }
                .apiep-page .gb-field { display: flex; flex-direction: column; flex: 1; min-width: 210px; }
                .apiep-page .gb-field-label { font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: #4338ca; margin-bottom: 6px; display: flex; align-items: center; gap: 6px; }
                .apiep-page .gb-field-label .gb-muted { color: #a1a1b5; font-weight: 600; letter-spacing: 0.04em; text-transform: none; }
                .apiep-page .gb-field .p-dropdown { border-radius: 10px; border-color: #e2e5ef; }
                .apiep-page .gb-field .p-dropdown:not(.p-disabled):hover { border-color: #a5b4fc; }
                .apiep-page .gb-field .p-dropdown:not(.p-disabled).p-focus { border-color: #4338ca; box-shadow: 0 0 0 3px rgba(67, 56, 202, 0.14); }
                .apiep-page .gb-segment { display: inline-flex; align-items: center; gap: 7px; padding: 8px 13px; border-radius: 10px; background: #eef2ff;
                    border: 1px dashed #a5b4fc; color: #3730a3; font-size: 0.78rem; font-weight: 600; font-family: ui-monospace, Menlo, Consolas, monospace; white-space: nowrap; }
                .apiep-page .gb-segment i { font-size: 0.75rem; }
                .apiep-page .gb-clear.p-button { border-radius: 10px; background: #fff; border: 1px solid #e2e5ef; color: #64748b; font-weight: 600; }
                .apiep-page .gb-clear.p-button:enabled:hover { background: #f8fafc; border-color: #cbd5e1; color: #475569; }
                .apiep-page .gb-module-field .p-dropdown { border-width: 2px; border-color: #4338ca; font-weight: 700; }

                .apiep-page .gb-hosts { background: #fff; border: 1px solid #e8eaf2; border-radius: 16px; padding: 14px 18px 12px; margin-bottom: 16px;
                    box-shadow: 0 2px 10px -4px rgba(15, 23, 42, 0.10); }
                .apiep-page .gb-hosts-head { display: flex; align-items: center; gap: 8px; font-size: 0.72rem; font-weight: 800; letter-spacing: 0.08em;
                    text-transform: uppercase; color: #4338ca; margin-bottom: 12px; }
                .apiep-page .gb-check.p-button { background: linear-gradient(135deg, #4338ca, #6366f1) !important; border: none !important; font-weight: 600; border-radius: 9px; }
                .apiep-page .gb-hosts-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
                .apiep-page .gb-host { border: 1px solid #e8eaf2; border-radius: 12px; padding: 11px 13px; background: #fbfbfe; }
                .apiep-page .gb-host-live { border-color: #a7f3d0; background: #f0fdf9; }
                .apiep-page .gb-host-down { border-color: #fecaca; background: #fef6f6; }
                .apiep-page .gb-host-blocked { border-color: #fde68a; background: #fffbeb; }
                .apiep-page .gb-host-none { opacity: 0.72; }
                .apiep-page .gb-host-top { display: flex; align-items: center; gap: 8px; margin-bottom: 7px; }
                .apiep-page .gb-host-state { display: inline-flex; align-items: center; gap: 6px; margin-left: auto; font-size: 0.68rem; font-weight: 700; color: #64748b; }
                .apiep-page .gb-host-dot { width: 7px; height: 7px; border-radius: 50%; background: #cbd5e1; }
                .apiep-page .gb-host-state-live { color: #047857; }
                .apiep-page .gb-host-state-live .gb-host-dot { background: #34d399; box-shadow: 0 0 0 3px rgba(52, 211, 153, 0.22); }
                .apiep-page .gb-host-state-down { color: #b91c1c; }
                .apiep-page .gb-host-state-down .gb-host-dot { background: #fb7185; box-shadow: 0 0 0 3px rgba(251, 113, 133, 0.22); }
                .apiep-page .gb-host-state-blocked { color: #b45309; }
                .apiep-page .gb-host-state-blocked .gb-host-dot { background: #fbbf24; box-shadow: 0 0 0 3px rgba(251, 191, 36, 0.24); }
                .apiep-page .gb-host-url { font-family: ui-monospace, Menlo, Consolas, monospace; font-size: 0.76rem; color: #334155; word-break: break-all; line-height: 1.45; }
                .apiep-page .gb-host-note { margin-top: 5px; font-size: 0.7rem; color: #94a3b8; line-height: 1.4; }
                .apiep-page .gb-hosts-foot { display: flex; align-items: flex-start; gap: 8px; margin-top: 11px; padding-top: 10px; border-top: 1px dashed #eef0f6;
                    font-size: 0.73rem; color: #7c8598; line-height: 1.5; word-break: break-all; }
                .apiep-page .gb-hosts-foot i { color: #a5b4fc; margin-top: 2px; }
                .apiep-page .gb-hostTag { display: inline-flex; align-items: center; padding: 2px 8px; border-radius: 6px; font-size: 0.62rem;
                    font-weight: 800; letter-spacing: 0.07em; border: 1px solid transparent; white-space: nowrap; }
                .apiep-page .gb-hostTag-sm { font-size: 0.56rem; padding: 1px 6px; }
                .apiep-page .gb-hostTag-server { background: #eef2ff; color: #4338ca; border-color: #c7d2fe; }
                .apiep-page .gb-hostTag-client { background: #fdf4ff; color: #a21caf; border-color: #f5d0fe; }
                @media (max-width: 900px) { .apiep-page .gb-hosts-grid { grid-template-columns: 1fr; } }

                .apiep-page .gb-split { display: flex; gap: 16px; height: 70vh; min-height: 500px; }
                .apiep-page .gb-sidebar, .apiep-page .gb-detail { background: #fff; border: 1px solid #e8eaf2; border-radius: 16px;
                    box-shadow: 0 2px 10px -4px rgba(15, 23, 42, 0.10); overflow-y: auto; }
                .apiep-page .gb-sidebar { width: 340px; flex-shrink: 0; }
                .apiep-page .gb-detail { flex: 1; display: flex; flex-direction: column; }
                .apiep-page .gb-sidebar::-webkit-scrollbar, .apiep-page .gb-detail::-webkit-scrollbar, .apiep-page .gb-res-body::-webkit-scrollbar { width: 8px; height: 8px; }
                .apiep-page .gb-sidebar::-webkit-scrollbar-thumb, .apiep-page .gb-detail::-webkit-scrollbar-thumb { background: #dfe3ec; border-radius: 8px; }
                .apiep-page .gb-sidebar::-webkit-scrollbar-thumb:hover, .apiep-page .gb-detail::-webkit-scrollbar-thumb:hover { background: #c7cddb; }
                .apiep-page .gb-res-body::-webkit-scrollbar-thumb { background: #334155; border-radius: 8px; }

                .apiep-page .gb-search { position: sticky; top: 0; z-index: 3; background: #fff; padding: 12px; border-bottom: 1px solid #eef0f6; }
                .apiep-page .gb-search .p-input-icon-left { width: 100%; }
                .apiep-page .gb-search .p-inputtext { width: 100%; border-radius: 10px; background: #f7f8fc; border-color: #e8eaf2; font-size: 0.85rem; padding-left: 2.4rem; }
                .apiep-page .gb-search .p-inputtext:enabled:focus { background: #fff; border-color: #4338ca; box-shadow: 0 0 0 3px rgba(67, 56, 202, 0.12); }
                .apiep-page .gb-search i { color: #a5abbd; }

                .apiep-page .gb-group-header { padding: 9px 14px; font-weight: 800; font-size: 0.68rem; text-transform: uppercase; letter-spacing: 0.09em;
                    position: sticky; top: 61px; z-index: 2; display: flex; align-items: center; gap: 8px; user-select: none; cursor: pointer; transition: filter .15s ease; }
                .apiep-page .gb-group-header:hover { filter: brightness(0.97); }
                .apiep-page .gb-group-count { font-weight: 700; font-size: 0.68rem; padding: 1px 8px; border-radius: 999px; background: rgba(255,255,255,0.72); }

                .apiep-page .gb-item { cursor: pointer; padding: 11px 14px 11px 15px; border-left: 3px solid transparent; border-bottom: 1px solid #f1f3f8;
                    transition: background-color .15s ease, border-color .15s ease, padding-left .15s ease; }
                .apiep-page .gb-item:hover { background: #f8f9fd; padding-left: 18px; }
                .apiep-page .gb-item.selected { background: linear-gradient(90deg, #eef2ff 0%, #fbfaff 100%); }
                .apiep-page .gb-item.selected .gb-item-title { color: #3730a3; }
                .apiep-page .gb-item-row { display: flex; align-items: center; gap: 8px; }
                .apiep-page .gb-item-title { font-weight: 600; font-size: 0.85rem; color: #1e293b; flex: 1; line-height: 1.3; }
                .apiep-page .gb-item-meta { font-size: 0.7rem; color: #a5abbd; }
                .apiep-page .gb-item-foot { display: flex; align-items: center; gap: 8px; margin-top: 6px; }
                .apiep-page .gb-empty-search { padding: 26px 16px; text-align: center; color: #a5abbd; font-size: 0.83rem; }

                .apiep-page .gb-pill { display: inline-flex; align-items: center; gap: 4px; padding: 2px 8px; border-radius: 999px;
                    font-size: 0.63rem; font-weight: 700; letter-spacing: 0.03em; line-height: 1.6; border: 1px solid transparent; white-space: nowrap; }
                .apiep-page .gb-pill-get { background: #ecfdf5; color: #047857; border-color: #a7f3d0; }
                .apiep-page .gb-pill-post { background: #fff7ed; color: #b45309; border-color: #fed7aa; }
                .apiep-page .gb-pill-success { background: #ecfdf5; color: #047857; border-color: #a7f3d0; }
                .apiep-page .gb-pill-danger { background: #fef2f2; color: #b91c1c; border-color: #fecaca; }
                .apiep-page .gb-pill-secondary { background: #f4f5f9; color: #64748b; border-color: #e2e5ef; }
                .apiep-page .gb-pill-info { background: #eff6ff; color: #1d4ed8; border-color: #bfdbfe; }

                .apiep-page .gb-detail-header { padding: 18px 24px; border-bottom: 1px solid #eef0f6; position: sticky; top: 0; z-index: 2; backdrop-filter: blur(6px); }
                .apiep-page .gb-crumb { display: flex; align-items: center; gap: 8px; font-size: 0.7rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; margin-bottom: 8px; }
                .apiep-page .gb-detail-title { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }
                .apiep-page .gb-detail-title h3 { margin: 0; font-size: 1.28rem; font-weight: 800; color: #1e293b; letter-spacing: -0.02em; }
                .apiep-page .gb-detail-path { margin-top: 8px; font-family: ui-monospace, Menlo, Consolas, monospace; font-size: 0.74rem; color: #94a3b8; word-break: break-all; }
                .apiep-page .gb-detail-body { padding: 18px 24px 24px; }
                .apiep-page .gb-detail-why { margin-top: 7px; display: flex; align-items: center; gap: 7px; font-size: 0.73rem; color: #7c8598; }
                .apiep-page .gb-detail-why i { color: #a5b4fc; font-size: 0.72rem; }

                .apiep-page .gb-step { padding: 2px 0; }
                .apiep-page .gb-step-title { font-weight: 600; font-size: 0.82rem; color: #475569; margin-bottom: 10px; padding: 9px 12px;
                    background: #f8f9fd; border: 1px solid #eef0f6; border-left: 3px solid #a5b4fc; border-radius: 8px; }
                .apiep-page .gb-hint { display: flex; align-items: flex-start; gap: 9px; margin-top: 12px; padding: 12px 14px; border-radius: 10px;
                    background: #f8f9fd; border: 1px dashed #e2e5ef; color: #7c8598; font-size: 0.8rem; line-height: 1.5; }
                .apiep-page .gb-hint i { color: #a5b4fc; margin-top: 2px; }
                .apiep-page .gb-hint-loading { background: #eef2ff; border-color: #c7d2fe; color: #3730a3; }

                .apiep-page .gb-reqbar { display: flex; align-items: stretch; border: 1px solid #e2e5ef; border-radius: 12px; overflow: hidden;
                    background: #fbfbfe; box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05); }
                .apiep-page .gb-reqbar-method { display: flex; align-items: center; padding: 0 15px; font-weight: 800; font-size: 0.74rem;
                    font-family: ui-monospace, Menlo, Consolas, monospace; letter-spacing: 0.06em; border-right: 1px solid #e2e5ef; white-space: nowrap; }
                .apiep-page .gb-method-get { color: #047857; background: #ecfdf5; }
                .apiep-page .gb-method-post { color: #b45309; background: #fff7ed; }
                .apiep-page .gb-reqbar-url { flex: 1; display: flex; align-items: center; padding: 11px 14px; font-family: ui-monospace, Menlo, Consolas, monospace;
                    font-size: 0.78rem; color: #475569; word-break: break-all; min-width: 0; }
                .apiep-page .gb-reqbar-action { display: flex; align-items: stretch; }
                .apiep-page .gb-reqbar-action .p-button { height: 100%; border-radius: 0 !important; padding-left: 18px; padding-right: 18px; font-weight: 600;
                    background: linear-gradient(135deg, #4338ca, #6366f1) !important; border: none !important; box-shadow: none !important; }
                .apiep-page .gb-reqbar-action .p-button:enabled:hover { background: linear-gradient(135deg, #3730a3, #4338ca) !important; }
                .apiep-page .gb-reqbar-action .p-button:disabled { background: #cbd5e1 !important; opacity: 1; }
                .apiep-page .gb-reqbar-action .gb-btn-danger.p-button { background: linear-gradient(135deg, #e11d48, #f43f5e) !important; }
                .apiep-page .gb-reqbar-action .gb-btn-danger.p-button:enabled:hover { background: linear-gradient(135deg, #be123c, #e11d48) !important; }

                .apiep-page .gb-editor { margin-top: 12px; border-radius: 12px; overflow: hidden; border: 1px solid #1e293b; }
                .apiep-page .gb-editor-bar { display: flex; align-items: center; gap: 8px; padding: 8px 13px; background: #111827;
                    color: #94a3b8; font-size: 0.72rem; font-weight: 600; letter-spacing: 0.04em; }
                .apiep-page .gb-editor-tag { padding: 1px 8px; border-radius: 999px; background: rgba(148, 163, 184, 0.16); color: #cbd5e1; font-size: 0.62rem; font-weight: 700; }
                .apiep-page .gb-json-edit { width: 100%; min-height: 150px; resize: vertical; box-sizing: border-box; display: block; border: none; outline: none;
                    background: #0f172a; color: #e2e8f0; font-family: ui-monospace, Menlo, Consolas, monospace; font-size: 0.78rem; line-height: 1.6; padding: 13px 15px; }
                .apiep-page .gb-json-edit::selection { background: rgba(67, 56, 202, 0.45); }

                .apiep-page .gb-res { margin-top: 12px; border-radius: 12px; overflow: hidden; border: 1px solid #1e293b; }
                .apiep-page .gb-res-bar { display: flex; align-items: center; gap: 12px; padding: 8px 13px; background: #111827; }
                .apiep-page .gb-res-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
                .apiep-page .gb-res.is-ok .gb-res-dot { background: #34d399; box-shadow: 0 0 0 3px rgba(52, 211, 153, 0.2); }
                .apiep-page .gb-res.is-err .gb-res-dot { background: #fb7185; box-shadow: 0 0 0 3px rgba(251, 113, 133, 0.2); }
                .apiep-page .gb-res-code { font-size: 0.74rem; font-weight: 800; letter-spacing: 0.04em; font-family: ui-monospace, Menlo, Consolas, monospace; }
                .apiep-page .gb-res.is-ok .gb-res-code { color: #6ee7b7; }
                .apiep-page .gb-res.is-err .gb-res-code { color: #fda4af; }
                .apiep-page .gb-res-meta { display: inline-flex; align-items: center; gap: 5px; font-size: 0.7rem; color: #94a3b8; }
                .apiep-page .gb-res-meta i { font-size: 0.68rem; }
                .apiep-page .gb-res-spacer { flex: 1; }
                .apiep-page .gb-copy { display: inline-flex; align-items: center; gap: 5px; padding: 3px 10px; border-radius: 7px; cursor: pointer;
                    background: rgba(148, 163, 184, 0.14); border: 1px solid rgba(148, 163, 184, 0.2); color: #cbd5e1; font-size: 0.68rem; font-weight: 600; transition: background-color .15s ease; }
                .apiep-page .gb-copy:hover { background: rgba(148, 163, 184, 0.26); color: #fff; }
                .apiep-page .gb-res-body { margin: 0; padding: 13px 15px; background: #0f172a; color: #e2e8f0; overflow: auto;
                    font-family: ui-monospace, Menlo, Consolas, monospace; font-size: 0.76rem; line-height: 1.6; white-space: pre-wrap; word-break: break-word; }

                .apiep-page .gb-empty { display: flex; flex-direction: column; align-items: center; justify-content: center; flex: 1; text-align: center; padding: 40px; }
                .apiep-page .gb-empty-icon { width: 88px; height: 88px; border-radius: 50%; display: flex; align-items: center; justify-content: center;
                    background: linear-gradient(135deg, #eef2ff, #e0e7ff); margin-bottom: 18px; }
                .apiep-page .gb-empty-icon i { font-size: 2.2rem; color: #818cf8; }
                .apiep-page .gb-empty h4 { margin: 0 0 6px; font-size: 1.02rem; font-weight: 700; color: #475569; }
                .apiep-page .gb-empty p { margin: 0; font-size: 0.84rem; color: #94a3b8; max-width: 380px; line-height: 1.55; }

                @media (max-width: 1100px) {
                    .apiep-page .gb-split { flex-direction: column; height: auto; }
                    .apiep-page .gb-sidebar { width: 100%; max-height: 360px; }
                    .apiep-page .gb-detail { min-height: 440px; }
                }
                @media (max-width: 640px) {
                    .apiep-page { padding: 0.75rem; }
                    .apiep-page .gb-hero { padding: 18px; }
                    .apiep-page .gb-stat { flex: 1; min-width: 78px; }
                    .apiep-page .gb-reqbar { flex-direction: column; align-items: stretch; }
                    .apiep-page .gb-reqbar-method { border-right: none; border-bottom: 1px solid #e2e5ef; padding: 8px 14px; }
                    .apiep-page .gb-reqbar-action .p-button { width: 100%; }
                    .apiep-page .gb-hide-sm { display: none; }
                    .apiep-page .gb-detail-header, .apiep-page .gb-detail-body { padding-left: 16px; padding-right: 16px; }
                }
            `}</style>

            {/* ── Hero ───────────────────────────────────────────── */}
            <div className="gb-hero">
                <div className="gb-hero-main">
                    <div className="gb-hero-icon">
                        <i className={mod.icon} />
                    </div>
                    <div>
                        <h2 className="gb-hero-title">API Endpoints — {mod.label} Tester</h2>
                        <p className="gb-hero-sub">
                            Pick a module below, then a client and branch — request URL, body and live response appear on the right. Master-data endpoints go to the host picked in Host resolution;
                            bill sync, bill details and SMS always stay on the client's base_url.
                        </p>
                    </div>
                </div>
                <div className="gb-stats">
                    <div className="gb-stat ok">
                        <div className="gb-stat-value">
                            <i className="pi pi-check-circle" />
                            {successCount}
                        </div>
                        <div className="gb-stat-label">Success</div>
                    </div>
                    <div className="gb-stat err">
                        <div className="gb-stat-value">
                            <i className="pi pi-times-circle" />
                            {failCount}
                        </div>
                        <div className="gb-stat-label">Failed</div>
                    </div>
                    <div className="gb-stat idle">
                        <div className="gb-stat-value">
                            <i className="pi pi-minus-circle" />
                            {notTested}
                        </div>
                        <div className="gb-stat-label">Not Tested</div>
                    </div>
                    <div className="gb-stat all">
                        <div className="gb-stat-value">
                            <i className="pi pi-bolt" />
                            {mod.endpoints.length}
                        </div>
                        <div className="gb-stat-label">Endpoints</div>
                        <div className="gb-progress">
                            <span style={{ width: `${coverage}%` }} />
                        </div>
                    </div>
                </div>
            </div>

            {/* ── Toolbar ────────────────────────────────────────── */}
            <div className="gb-toolbar">
                <div className="gb-field gb-module-field" style={{ maxWidth: 220 }}>
                    <label className="gb-field-label">
                        <i className="pi pi-th-large" /> Module
                    </label>
                    <Dropdown value={activeModule} options={MODULE_OPTIONS} onChange={(e) => setActiveModule(e.value)} className="w-full" />
                </div>

                <div className="gb-field">
                    <label className="gb-field-label">
                        <i className="pi pi-building" /> Client
                    </label>
                    <Dropdown
                        value={selectedClient}
                        options={clients}
                        onChange={(e) => {
                            const row = clients.find((c) => c.value === e.value);
                            setSelectedClient(e.value);
                            setSelectedBranch(null);
                            setBranches([]);
                            setClientUrls({ base_url: row?.base_url || '', server_url: row?.server_url || '' });
                            setHostProbe({ server: null, client: null });
                            fetchBranches(e.value);
                        }}
                        placeholder="Select Client"
                        filter
                        className="w-full"
                    />
                </div>

                <div className="gb-field">
                    <label className="gb-field-label">
                        <i className="pi pi-sitemap" /> Branch <span className="gb-muted">(segment)</span>
                        {branchesLoading && <i className="pi pi-spin pi-spinner" style={{ fontSize: '0.75rem' }} />}
                    </label>
                    <Dropdown
                        value={selectedBranch}
                        options={branches}
                        onChange={(e) => setSelectedBranch(e.value)}
                        placeholder={branchesLoading ? 'Loading branches…' : 'Select Branch'}
                        filter
                        disabled={!selectedClient || branchesLoading}
                        className="w-full"
                    />
                </div>

                <div className="gb-field" style={{ maxWidth: 230 }}>
                    <label className="gb-field-label">
                        <i className="pi pi-server" /> Host
                    </label>
                    <Dropdown value={hostMode} options={HOST_MODES} onChange={(e) => setHostMode(e.value)} className="w-full" />
                </div>

                <div className="flex gap-2 align-items-center" style={{ paddingBottom: 1 }}>
                    {selectedBranch && (
                        <span className="gb-segment gb-hide-sm">
                            <i className="pi pi-link" />
                            {currentSegment()}
                        </span>
                    )}
                    <Button
                        label="Clear Results"
                        icon="pi pi-refresh"
                        className="gb-clear"
                        onClick={() => {
                            setResults({});
                            setPostResults({});
                            setPostBody({});
                            setExtraParams({});
                            setUploadFile(null);
                            setUploadExtraFields('{}');
                            setSelectedClient(null);
                            setSelectedBranch(null);
                            setBranches([]);
                            setClientUrls({ base_url: '', server_url: '' });
                            setHostProbe({ server: null, client: null });
                        }}
                    />
                </div>
            </div>

            {/* ── Host resolution ────────────────────────────────── */}
            {selectedClient && (
                <div className="gb-hosts">
                    <div className="gb-hosts-head">
                        <i className="pi pi-sitemap" />
                        <span>Host resolution</span>
                        <span className="gb-res-spacer" />
                        <Button label={probing ? 'Checking…' : 'Check Hosts'} icon="pi pi-bolt" className="p-button-sm gb-check" onClick={checkHosts} loading={probing} disabled={!selectedBranch} />
                    </div>
                    <div className="gb-hosts-grid">
                        <HostCard
                            tag="SERVER"
                            tone="server"
                            url={serverUrl}
                            probe={hostProbe.server}
                            empty="No server_url set for this client — master data stays on the client deployment."
                            note="client_creation.server_url — master data & callbacks when Server is picked"
                        />
                        <HostCard tag="CLIENT" tone="client" url={clientUrl} probe={hostProbe.client} empty="No base_url set for this client." note="client_creation.base_url — always serves bill sync, bill details and SMS" />
                    </div>
                    <div className="gb-hosts-foot">
                        <i className="pi pi-info-circle" />
                        <span>
                            {hostMode === 'local'
                                ? 'Host override: every request goes to the backend serving this page.'
                                : `Master data → ${resolveHost({ host: 'server' }).baseUrl || displayBaseUrl()} · Bill sync / SMS → ${resolveHost({ host: 'client' }).baseUrl || displayBaseUrl()}`}
                        </span>
                    </div>
                </div>
            )}

            {/* ── Split view ─────────────────────────────────────── */}
            <div className="gb-split">
                <div className="gb-sidebar">
                    <div className="gb-search">
                        <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search endpoints…" />
                        </span>
                    </div>

                    {Object.keys(groupedEndpoints).length === 0 && (
                        <div className="gb-empty-search">
                            <i className="pi pi-inbox" style={{ fontSize: '1.6rem', display: 'block', marginBottom: 8, color: '#cbd5e1' }} />
                            No endpoints match your search.
                        </div>
                    )}

                    {Object.entries(groupedEndpoints).map(([group, eps]) => {
                        const gs = groupStyle(group);
                        const isCollapsed = collapsedGroups.has(group);
                        return (
                            <div key={group}>
                                <div className="gb-group-header" style={{ background: gs.bg, color: gs.color, borderLeft: `4px solid ${gs.accent}` }} onClick={() => toggleGroup(group)}>
                                    <i className={gs.icon} />
                                    <span style={{ flex: 1 }}>{group}</span>
                                    <span className="gb-group-count">{eps.length}</span>
                                    <i className={`pi ${isCollapsed ? 'pi-chevron-right' : 'pi-chevron-down'}`} style={{ fontSize: '0.65rem' }} />
                                </div>
                                {!isCollapsed &&
                                    eps.map((ep) => {
                                        const info = statusInfo(ep);
                                        const isSelected = selectedEndpoint?.key === ep.key;
                                        const rkey = rk(ep.key);
                                        const r = postResults[rkey] || results[rkey];
                                        return (
                                            <div key={ep.key} className={`gb-item${isSelected ? ' selected' : ''}`} style={{ borderLeftColor: isSelected ? gs.accent : 'transparent' }} onClick={() => selectEndpoint(ep)}>
                                                <div className="gb-item-row">
                                                    <Pill tone={ep.method.toLowerCase()}>{ep.method}</Pill>
                                                    <span className="gb-item-title">{ep.label}</span>
                                                    {ep.host !== 'local' && <span className={`gb-hostTag gb-hostTag-sm gb-hostTag-${ep.host}`}>{HOST_LABELS[ep.host]}</span>}
                                                    {(runningKeys.has(rkey) || postLoading[rkey]) && <i className="pi pi-spin pi-spinner" style={{ color: gs.accent, fontSize: '0.8rem' }} />}
                                                </div>
                                                <div className="gb-item-foot">
                                                    <Pill tone={info.severity}>{info.text}</Pill>
                                                    <span className="gb-item-meta">{r ? `${r.duration} ms · ${r.testedAt}` : 'Not tested yet'}</span>
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>
                        );
                    })}
                </div>

                <div className="gb-detail">
                    {selectedEndpoint ? (
                        <>
                            <div className="gb-detail-header" style={{ background: `linear-gradient(180deg, ${detailStyle.soft} 0%, rgba(255,255,255,0.9) 100%)` }}>
                                <div className="gb-crumb" style={{ color: detailStyle.color }}>
                                    <i className={detailStyle.icon} style={{ fontSize: '0.75rem' }} />
                                    <span>
                                        {mod.label} · {selectedEndpoint.group}
                                    </span>
                                </div>
                                <div className="gb-detail-title">
                                    <Pill tone={selectedEndpoint.method.toLowerCase()}>{selectedEndpoint.method}</Pill>
                                    <h3>{selectedEndpoint.label}</h3>
                                    {selectedEndpoint.host !== 'local' && <span className={`gb-hostTag gb-hostTag-${selectedEndpoint.host}`}>{HOST_LABELS[selectedEndpoint.host]}</span>}
                                </div>
                                <div className="gb-detail-path">/{selectedEndpoint.path}</div>
                                <div className="gb-detail-why">
                                    <i className="pi pi-server" /> {resolveHost(selectedEndpoint).why}
                                </div>
                            </div>
                            <div className="gb-detail-body">{renderDetailBody()}</div>
                        </>
                    ) : (
                        <div className="gb-empty">
                            <div className="gb-empty-icon">
                                <i className="pi pi-send" />
                            </div>
                            <h4>No endpoint selected</h4>
                            <p>Pick an endpoint from the list to view its request URL, run it, and inspect the response.</p>
                        </div>
                    )}
                </div>
            </div>

            {/* Reset Masters confirmation (GS Billing module only) */}
            <Dialog
                header="Reset All Masters"
                visible={resetVisible}
                style={{ width: '440px' }}
                onHide={() => setResetVisible(false)}
                footer={
                    <div className="flex justify-content-end gap-2">
                        <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={() => setResetVisible(false)} disabled={resetLoading} />
                        <Button label="Reset Masters" icon="pi pi-database" className="p-button-danger" onClick={resetMasters} loading={resetLoading} />
                    </div>
                }
            >
                <div className="flex align-items-center gap-3">
                    <i className="pi pi-exclamation-triangle text-orange-500" style={{ fontSize: '2.5rem' }} />
                    <span>
                        Are you sure you want to reset all masters for branch <strong>{currentSegment()}</strong>?
                        <br />
                        <small style={{ color: '#888' }}>This cannot be undone.</small>
                    </span>
                </div>
            </Dialog>
        </div>
    );
}
